import React from 'react'
import { Text } from 'theme-ui'
import StyledLink from 'components/Organization/LandingPageCommonComponents/StyledLink'
import { CONTROLDText } from 'ui/CONTROLD'
import { FAQItem } from 'components/FrequentlyAskedQuestions'

export const frequentlyAskedQuestions: FAQItem[] = [
  {
    question: `Do the ${CONTROLDText} Free DNS servers log my browsing activity?`,
    answer: (
      <Text>
        We do not store any individual browsing history, timestamps, or logs. What&apos;s more, we
        don&apos;t use any 3rd party tracking or analytics services to track your activity on this
        website either. Read more about our data collection practices in our{' '}
        <StyledLink to="/privacy">privacy policy.</StyledLink>
      </Text>
    ),
  },
  {
    question: 'How reliable and fast are these free DNS servers?',
    answer: (
      <Text>
        With 35 primary locations, {CONTROLDText} has free DNS servers in convenient and{' '}
        <StyledLink to="/network">high-traffic places</StyledLink> across the globe. These give you
        a reliable and stable connection whenever you need it.
      </Text>
    ),
  },
  {
    question: 'Can this DNS service block malware and other malicious content?',
    answer: (
      <Text>
        With thousands of satisfied customers and a{' '}
        <StyledLink to="https://www.g2.com/products/controld/reviews">4.5 rating on G2</StyledLink>,{' '}
        {CONTROLDText} keeps you safe on the internet, reliably blocks unwanted apps and websites,
        and keeps your kids protected from adult content, gambling, and dating websites.
      </Text>
    ),
  },
  {
    question: 'Are the free DNS servers encrypted?',
    answer: (
      <Text>
        {CONTROLDText} supports all modern (and encrypted) protocols like DNS-over-HTTPS/3 and
        DNS-over-TLS. It also has support for custom filtering, where highly granular web filters
        provide power users with ultimate control, with general curated lists allowing DNS security
        newcomers to gain maximum benefits with minimal technical knowledge.
      </Text>
    ),
  },
  {
    question: `Who are the people behind ${CONTROLDText}?`,
    answer: (
      <Text>
        {CONTROLDText} is the brainchild of popular Toronto-based VPN service Windscribe,
        that&apos;s consistently ranked as one of the best free VPNs in the world and has{' '}
        <StyledLink to="/privacy">fundamental safeguards</StyledLink> in place to protect and
        preserve your privacy. Windscribe does not engage in any form of paid advertising, does not
        track any user actions on its website, and allows users to sign up without a name or email
        address.{' '}
      </Text>
    ),
  },
]
